import { createApi } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from '../baseQueries/axiosBaseQuery';
import { CONFIG } from '../../constants';

export const inventoryApi = createApi({
  reducerPath: 'inventoryApi',
  baseQuery: axiosBaseQuery({ baseUrl: CONFIG.API_INVENTORY_URL || '' }),
  endpoints: builder => ({
    getInventoryAdjustmentsForProjectItem: builder.query({
      query: ({ productId, projectId, projectItemId }) => ({
        url: `/stock-adjustment/get-all/${productId}?projectId=${projectId}&projectItemId=${projectItemId}`,
      }),
      keepUnusedDataFor: 5,
    }),
    getAllWarehouses: builder.query({
      query: () => ({ url: '/warehouses/get-all' }),
      keepUnusedDataFor: 30,
    }),
  }),
});

export const {
  useLazyGetInventoryAdjustmentsForProjectItemQuery,
  useLazyGetAllWarehousesQuery,
} = inventoryApi;
